import { Component, HostBinding, ViewEncapsulation } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'form-category-wrapper',
  standalone: false,
  encapsulation: ViewEncapsulation.None,
  styles: [
    `
      .form-category-wrapper {
        display: flex;
        flex-direction: column;

        &--header {
          font-weight: 600;
          color: var(--p-text-color);
          margin: 0.7rem 0;
        }
        &--info {
          font-weight: 400;
          color: var(--p-text-muted-color);
        }
      }
    `,
  ],
  template: `
    <div
      *ngIf="props.label || props['info']"
      class="form-category-wrapper--header"
    >
      <div *ngIf="props.label" class="form-category-wrapper--title">
        {{ props['translate'] ? (props.label || '' | translate) : props.label }}
      </div>
      <div *ngIf="props['info']" class="form-category-wrapper--info">
        {{
          props['translate'] ? (props['info'] || '' | translate) : props['info']
        }}
      </div>
    </div>

    <div>
      <ng-container #fieldComponent></ng-container>
    </div>
  `,
})
export class FormCategoryWrapperType extends FieldWrapper {
  @HostBinding('class')
  readonly cssClass = 'form-category-wrapper';
}
